module.exports = __webpack_public_path__ + "static/media/WBN_li.ed4893b2.svg";